import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { provisionData } from '../interfaces/provision';
import { informeFacturas, reporteFacturacion } from '../interfaces/facturacion';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';


@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  public exportAsExcelFile2(json: any[], Name1, excelFileName: string): void {
    /*
    let worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    let workbook: XLSX.WorkBook = { Sheets: { data: worksheet}, SheetNames: ['Iniciadas'] };
    */
    const worksheet1 = XLSX.utils.aoa_to_sheet(json);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet1, Name1);
    let excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    setTimeout(() => {
      this.saveAsExcelFile(excelBuffer, excelFileName);
    }, 1500);
  }

  public exportAsExcelFile(json: any[], json1: any[], Name1, Name2, excelFileName: string): void {
    /*
    let worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    let workbook: XLSX.WorkBook = { Sheets: { data: worksheet}, SheetNames: ['Iniciadas'] };
    */
    const worksheet1 = XLSX.utils.aoa_to_sheet(json);
    const worksheet2 = XLSX.utils.aoa_to_sheet(json1);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet1, Name1);
    XLSX.utils.book_append_sheet(workbook, worksheet2, Name2);
    let excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    setTimeout(() => {
      this.saveAsExcelFile(excelBuffer, excelFileName);
    }, 1500);
  }

  public exportAsExcelFile4(json: any[], json1: any[], json2: any[], json3: any[], Name1, Name2, Name3, Name4, excelFileName: string): void {
    /*
    let worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    let workbook: XLSX.WorkBook = { Sheets: { data: worksheet}, SheetNames: ['Iniciadas'] };
    */
    const worksheet1 = XLSX.utils.aoa_to_sheet(json);
    const worksheet2 = XLSX.utils.aoa_to_sheet(json1);
    const worksheet3 = XLSX.utils.aoa_to_sheet(json2);
    const worksheet4 = XLSX.utils.aoa_to_sheet(json3);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet1, Name1);
    XLSX.utils.book_append_sheet(workbook, worksheet2, Name2);
    XLSX.utils.book_append_sheet(workbook, worksheet3, Name3);
    XLSX.utils.book_append_sheet(workbook, worksheet4, Name4);
    let excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    setTimeout(() => {
      this.saveAsExcelFile(excelBuffer, excelFileName);
    }, 1500);
  }

  public exportExcelInvalidProvision(provisionData: provisionData) {
    const workbook = XLSX.utils.book_new();

    for (const request of provisionData.requestsDeny) {
      const headersInvalidRecords = ['NUI', 'Identificación', 'Dato cargado en archivo', 'Dato en base de datos', 'Error']
      const headersEmptyRecords = ['Error', 'Seccional', 'Dias', 'Factura Mes', 'Subsidio', 'Valor Dia Factura']
      const worksheet1 = XLSX.utils.json_to_sheet(request.provision.invalidRecords);
      // Obtener el rango de la hoja
      const range = XLSX.utils.decode_range(worksheet1['!ref']);

      // Aplicar `wrapText: true` a todas las celdas
      for (let row = range.s.r; row <= range.e.r; row++) {
        for (let col = range.s.c; col <= range.e.c; col++) {
          const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
          if (!worksheet1[cellAddress]) continue; // Si la celda no existe, saltar

          worksheet1[cellAddress].s = {
            alignment: {
              wrapText: true
            }
          };
        }
      }

      if (request.provision.invalidRecords[0].nui) {
        worksheet1["!cols"] = [{ wch: 10 }, { wch: 20 }, { wch: 20 }, { wch: 20 }, { wch: 30 }];
        XLSX.utils.sheet_add_aoa(worksheet1, [headersInvalidRecords], { origin: "A1" });
        XLSX.utils.book_append_sheet(workbook, worksheet1, `${request.seccional}-${request.id_solicitud}`); // Sheet con nombre de seccional y i
      } else {
        worksheet1["!cols"] = [{ wch: 50 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }];
        XLSX.utils.sheet_add_aoa(worksheet1, [headersEmptyRecords], { origin: "A1" });
        XLSX.utils.book_append_sheet(workbook, worksheet1, `${request.seccional}-${request.id_solicitud}`); // Sheet con nombre de seccional y i
      }
    }

    let excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    setTimeout(() => {
      this.saveAsExcelFile(excelBuffer, 'Reporte Provision');
    }, 1500);
  }

  public exportExcelFacturacion(informe: informeFacturas[]) {
    let auxInforme: reporteFacturacion[] = []
console.log("Aquiii...", informe)
    informe.forEach((data) => {
      switch (data.cufe_status) {
        case 'Accepted':
          data
          data.cufe_status = 'Accepted: Factura aprobada y con CUFE'
          break;
        case 'Draft':
          data.cufe_status = 'Draft: Factura sin enviar a la DIAN'
          break;
        case 'Rejected':
          data.cufe_status = 'Rejected: Factura rechazada por la DIAN'
          break;
        case 'Sending':
          data.cufe_status = 'Sending: Factura en proceso de envio a la DIAN'
          break;
        case 'Error':
          data.cufe_status = 'Error: Factura fallo en enviarse a Siigo'
          break;
        default:
          break;
      }
      auxInforme.push({
        'ID Registro Facturación': data.id_registro_facturacion,
        'NUI': data.nui,
        'Envio a Siigo': data.success ? 'Completo' : 'Incompleto',
        'Identificacion': data.cc,
        'ID Solicitud Facturacion': data.id_solicitud,
        'ID Factura': data.id_factura,
        'Nombre Factura': data.name_factura ? data.name_factura : '-',
        'Estado CUFE': data.cufe_status ? data.cufe_status : '-',
        'Mensaje': data.message
      })
    })
    const workbook = XLSX.utils.book_new();
    const id_solicitud = auxInforme[0]['ID Solicitud Facturacion']
    const headersRecords = ['ID Registro Facturación', 'NUI', 'Estado Proceso', 'Identificación', 'ID Solicitud Facturación', 'ID Factura', 'Nombre Factura', 'Estado CUFE', 'Mensaje']
    const worksheet1 = XLSX.utils.json_to_sheet(auxInforme);
    // Obtener el rango de la hoja
    const range = XLSX.utils.decode_range(worksheet1['!ref']);

    // Aplicar `wrapText: true` a todas las celdas
    for (let row = range.s.r; row <= range.e.r; row++) {
      for (let col = range.s.c; col <= range.e.c; col++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: col });
        if (!worksheet1[cellAddress]) continue; // Si la celda no existe, saltar

        worksheet1[cellAddress].s = {
          alignment: {
            wrapText: true
          }
        };
      }
    }
    worksheet1["!cols"] = [{ wch: 10 }, { wch: 10 }, { wch: 15 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 30 }, { wch: 30 }];
    XLSX.utils.sheet_add_aoa(worksheet1, [headersRecords], { origin: "A1" });
    XLSX.utils.book_append_sheet(workbook, worksheet1, `${id_solicitud}`); // Sheet con nombre de seccional


    let excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    setTimeout(() => {
      this.saveAsExcelFile(excelBuffer, `Reporte Facturación ${id_solicitud}`);
    }, 1500);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

}
